export const JiraSoftwareMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 43.8003C27.85 39.9493 27.85 33.7063 24 29.8563V29.8543V29.8563L11.152 17.0483L5.308 22.8923C4.696 23.5043 4.696 24.4973 5.308 25.1103L24 43.8023V43.8003Z"
      fill="white"
    />
    <path
      d="M42.6921 22.8912L24.0001 4.19922L23.9421 4.25822L23.9601 4.24422C20.1521 8.09822 20.1641 14.3082 24.0001 18.1452L36.8441 30.9572L42.6921 25.1092C43.3041 24.4972 43.3041 23.5042 42.6921 22.8912Z"
      fill="white"
    />
    <path
      d="M24 18.1442C20.163 14.3072 20.152 8.09716 23.96 4.24316L10.627 17.5762L17.6 24.5492L24.002 18.1472L24 18.1452V18.1442Z"
      fill="url(#paint0_linear_818_546)"
    />
    <path
      d="M30.395 23.4615L24 29.8565C27.85 33.7075 27.85 39.9504 24 43.8004L37.367 30.4335L30.394 23.4604L30.395 23.4615Z"
      fill="url(#paint1_linear_818_546)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_546"
        x1="23.69"
        y1="11.4862"
        x2="15.603"
        y2="19.5732"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.068" stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_546"
        x1="24.511"
        y1="36.3184"
        x2="33.367"
        y2="27.4624"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.068" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.908" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
